import React, { useState, useEffect } from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const EditMetaData = ({
  id_R,
  closeMetaData,
  isMetaDataOpen,
  identity,
  setIdentity,
  setViewIDOpen,
  setIsSaveChanges,
}) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    // Disable the button if identity is empty
    setIsButtonDisabled(identity.trim() === "");
  }, [identity]);

  const handleBackButtonClick = () => {
    // Close the current modal
    closeMetaData();

    // Open the previous modal

    setViewIDOpen(true);
  };
  const handleNextButtonClick = async () => {
    if (!isButtonDisabled) {
      // Close the current modal
      closeMetaData();

      // Open the next modal
      setIsSaveChanges(true);
    }
  };

  return (
    <SlidePanel
      isOpen={isMetaDataOpen}
      onClose={closeMetaData}
      width={window?.innerWidth * 0.5}
    >
      <div className="h-full flex flex-col justify-between p-6">
        <div
          onClick={closeMetaData}
          className="absolute top-0 right-0 h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] flex items-center justify-center cursor-pointer z-50"
        >
          <X color="#fff" size={20} />
        </div>
        <div className="flex flex-col h-full">
          <div className="mt-10 mx-auto items-center">
            <p className="text-[#000] text-xl font-bold">Edit metadata</p>
            <div className="text-[#000] mt-[30px] text-[15px] font-[300]">
              <p className="w-[99%]">
                ⚠️ This option allows you to update the information associated
                with the National ID, such as the ID number. Only proceed with
                these changes if there is a valid reason and sufficient evidence
                that the current details are incorrect or outdated.
              </p>
            </div>
          </div>

          <div className="flex-1 overflow-y-auto mt-8">
            <div className="flex w-full flex-col justify-center">
              <label
                htmlFor="identity"
                className="mb-1 text-[16px] font-normal text-[#000]"
              >
                Identity document Number
              </label>
              <input
                type="text"
                id="identity"
                name="identity"
                placeholder="Enter your identity"
                value={identity}
                onChange={(e) => setIdentity(e.target.value)}
                className="w-full h-10 px-4 border bg-[#EAEAEA] border-[#EAEAEA] border-[1px] rounded-[4px]"
              />
            </div>
          </div>

          <div className="flex w-full items-center justify-between gap-5">
            <button
              onClick={handleBackButtonClick}
              data-modal-toggle={id_R}
              type="button"
              className="text-[#000] bg-[#7FB8EB] hover:bg-[#7FB8EB] focus:outline-none font-medium rounded w-full text-sm px-8 py-2.5 text-center"
            >
              Back
            </button>

            <button
              onClick={handleNextButtonClick}
              data-modal-toggle={id_R}
              type="button"
              className={`text-white focus:outline-none font-medium rounded w-full text-sm px-8 py-2.5 text-center ${
                isButtonDisabled
                  ? "bg-[#D9D9D9] cursor-not-allowed"
                  : "bg-[#074073] hover:bg-[#074073]"
              }`}
              disabled={isButtonDisabled}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default EditMetaData;
